import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTypedTheme } from '@monorepo-web/styles';
import { FormControl, Select, Checkbox, ListItemText, Grid } from '@mui/material';
import { Container } from '../Container';
import { ButtonWrapper, StyledButton, ColumnTitle, StyledMenuItem } from './style';
import { useIsMobile } from '@monorepo-web/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import MarcarDesmarcarButton from './BotaoMarcarDesmarcar/index';
export default function Dropdown(props) {
    var _a;
    const isMobile = useIsMobile();
    const theme = useTypedTheme();
    const [openSelect, setOpenSelect] = useState(false);
    const [localSelected, setLocalSelected] = useState([]);
    const columnIndex = (_a = props.secondColumnSeparator) !== null && _a !== void 0 ? _a : Math.ceil(props.options.length / 2);
    useEffect(() => {
        var _a;
        const selectedArr = props.selected && props.selected.length > 0 ? (_a = props.selected) === null || _a === void 0 ? void 0 : _a.map((item) => props.optionNameLabel(item, "name")) : [];
        setLocalSelected(selectedArr);
    }, [props.selected]);
    const handleClick = () => {
        props.onSelect([...localSelected], false);
        setOpenSelect(false);
    };
    const clickOnBench = (bench) => {
        if (localSelected === null || localSelected === void 0 ? void 0 : localSelected.includes(bench)) {
            const arr = [...localSelected];
            arr.splice(localSelected.indexOf(bench), 1);
            setLocalSelected(arr);
        }
        else {
            setLocalSelected([...localSelected, bench]);
        }
    };
    const avoidPropagation = (e) => {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        else if (window.event) {
            window.event.cancelBubble = true;
        }
    };
    const MarcarDesmarcarColumn = ({ column }) => {
        const sliceStart = column === 1 ? 0 : columnIndex;
        const sliceEnd = column === 1 ? columnIndex : props.options.length;
        const columnOptions = props.options.slice(sliceStart, sliceEnd).map(option => props.optionNameLabel(option, "name"));
        const selectedInColumn = localSelected.filter(name => columnOptions.includes(name));
        const handleChange = (newSelection) => {
            const others = localSelected.filter(name => !columnOptions.includes(name));
            setLocalSelected([...others, ...newSelection]);
        };
        return (_jsx(MarcarDesmarcarButton, { selectedItems: selectedInColumn, allOptions: columnOptions, onChange: handleChange, avoidPropagation: avoidPropagation }));
    };
    const iconProps = {
        color: (props.disabled || props.options.length === 0) ? theme.disabledColor : theme.iconsColor,
        paddingBottom: openSelect ? "0" : "8px",
        paddingTop: openSelect ? "8px" : "0",
        cursor: "pointer",
    };
    const MenuItems = ({ sliceStart, sliceEnd }) => {
        return (_jsx(_Fragment, { children: props.options
                .slice(sliceStart, sliceEnd)
                .map((item) => (_jsxs(StyledMenuItem, Object.assign({ value: props.optionNameLabel(item, "name"), onClick: () => {
                    clickOnBench(props.optionNameLabel(item, "name"));
                } }, { children: [_jsx(Checkbox, { checked: localSelected === null || localSelected === void 0 ? void 0 : localSelected.includes(props.optionNameLabel(item, "name")), icon: _jsx(FontAwesomeIcon, { icon: faSquare, style: { color: theme.backgroundColorSecondary }, fontSize: '1.5rem' }), checkedIcon: _jsx(FontAwesomeIcon, { icon: faSquareCheck, style: { color: theme.backgroundColorSecondary }, fontSize: '1.5rem' }) }), _jsx(ListItemText, { primary: props.optionNameLabel(item, "label") })] }), props.optionNameLabel(item, "label")))) }));
    };
    const FirstHeader = () => {
        return (_jsxs(_Fragment, { children: [props.column1Title ? (_jsx(ColumnTitle, { children: props.column1Title })) : null, props.botoesMarcarDesmarcar ? (_jsx(MarcarDesmarcarColumn, { column: 1 })) : null] }));
    };
    const SecondHeader = () => {
        return (_jsxs(_Fragment, { children: [props.column2Title ? (_jsx(ColumnTitle, { children: props.column2Title })) : null, props.botoesMarcarDesmarcar ? (_jsx(MarcarDesmarcarColumn, { column: 2 })) : null] }));
    };
    const DropdownGrid = ({ maxHeight }) => (_jsxs(Grid, Object.assign({ minWidth: isMobile ? '' : 400 }, { children: [_jsxs(Grid, Object.assign({ container: true }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 6 }, { children: _jsx(FirstHeader, {}) })), _jsx(Grid, Object.assign({ item: true, xs: 6 }, { children: _jsx(SecondHeader, {}) }))] })), _jsxs(Grid, Object.assign({ container: true }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 6, style: { overflowY: 'auto', maxHeight } }, { children: _jsx(MenuItems, { sliceStart: 0, sliceEnd: columnIndex }) })), _jsx(Grid, Object.assign({ item: true, xs: 6, style: { overflowY: 'auto', maxHeight } }, { children: _jsx(MenuItems, { sliceStart: columnIndex, sliceEnd: props.options.length }) }))] }))] })));
    return (_jsx(Container, { children: _jsx(FormControl, Object.assign({ variant: "standard", style: { display: 'flex', flexDirection: 'row' } }, { children: _jsxs(Select, Object.assign({ value: [], disabled: props.disabled || props.options.length === 0, id: "demo-multiple-checkbox-label", multiple: true, MenuProps: {
                    PaperProps: {
                        style: {
                            overflowY: 'hidden',
                            backgroundColor: theme.dropSelectorColor,
                        },
                    },
                }, open: openSelect, onClick: () => {
                    if (!props.disabled && props.options.length !== 0) { // n�o permitir utilizar bot�o quando minizar o modal de loading
                        setOpenSelect(!openSelect);
                    }
                }, displayEmpty: true, renderValue: () => {
                    return _jsx("div", Object.assign({ style: { color: theme.titleFontColor, paddingLeft: 2 } }, { children: props.title }));
                }, inputProps: {
                    'aria-label': 'Without label',
                    IconComponent: () => props.IconComponent ? props.IconComponent(iconProps, openSelect) : _jsx(FontAwesomeIcon, { icon: (openSelect ? faSortUp : faSortDown), style: {
                            color: iconProps.color,
                            paddingBottom: iconProps.paddingBottom,
                            paddingTop: iconProps.paddingTop,
                            cursor: iconProps.cursor,
                        }, fontSize: '1rem' }),
                } }, { children: [_jsx(Grid, Object.assign({ onClick: (e) => {
                            avoidPropagation(e);
                            setOpenSelect(true);
                        }, container: true, style: { maxHeight: '77vh' } }, { children: _jsx(DropdownGrid, { maxHeight: isMobile ? '68vh' : '50vh' }) })), _jsx(ButtonWrapper, { children: _jsx(StyledButton, Object.assign({ onClick: (e) => {
                                avoidPropagation(e);
                                handleClick();
                            } }, { children: "Aplicar" })) })] })) })) }));
}
